import { render } from "./BaseStations.vue?vue&type=template&id=ebdc324a&scoped=true"
import script from "./BaseStations.vue?vue&type=script&lang=js"
export * from "./BaseStations.vue?vue&type=script&lang=js"

import "./BaseStations.vue?vue&type=style&index=0&id=ebdc324a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebdc324a"]])

export default __exports__